import isSiteReset from './is-site-reset';

export default {
  isSiteReset,
};
